import { Button, CountrySelect, Header } from '../../Generic'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { SaltedgeCountry } from '@/types/saltedge'
interface SelectCountryProps {
  apiCountries: SaltedgeCountry[]
  country: SaltedgeCountry | null
  handleCountry: (value: SaltedgeCountry) => void
  handleProceed: () => void
  isMobile: boolean
}

export const SelectCountry = observer(
  ({ apiCountries, country, handleCountry, handleProceed, isMobile }: SelectCountryProps) => {
    const store = useContext(StoreContext)
    const { themeId } = store.InterfaceState
    const { saltedgePage: trans } = store.TranslationsState.translations

    return (
      <>
        <Header>{trans.chooseCountryHeader}</Header>
        <div className="generic__country-wrap">
          {isMobile ? (
            <>
              <CountrySelect
                externalList={apiCountries}
                value={country}
                onChange={(value) => value && handleCountry(value as unknown as SaltedgeCountry)}
                autoFocus={true}
                defaultMenuIsOpen={false}
                placeholder={trans.countrySelectPlaceholder}
                showCheckmark
              />
            </>
          ) : (
            <>
              <CountrySelect
                externalList={apiCountries}
                value={country}
                onChange={(value) => value && handleCountry(value as unknown as SaltedgeCountry)}
                autoFocus={false}
                defaultMenuIsOpen={false}
                placeholder={trans.countrySelectPlaceholder}
                showCheckmark
              />
            </>
          )}
        </div>

        <div className="layout__content-container-bottom-fixed">
          {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
          <Button
            onClick={() => handleProceed()}
            disabled={!country}
            className="button--w164"
            id="page-submit"
          >
            <span className="generic__button-text">{trans.continue}</span>
          </Button>
        </div>
      </>
    )
  }
)
